const FormBlock = () => {

    jQuery(document).ready(function(){
        jQuery(document).on('gform_confirmation_loaded', function(event, formId){
            var headingMessage = document.getElementById('content-' + formId);
            if (headingMessage) {
                headingMessage.style.display = 'none';
            }
        });
    })

};

export default FormBlock;